// extracted by mini-css-extract-plugin
export default {"cardTitle":"style_cardTitle__kW9V0","cabecalho":"style_cabecalho__2x-NE","separador":"style_separador__1C+rE"};